// extracted by mini-css-extract-plugin
module.exports = {"appVersion":"_2pZSzVDH","appVersionVisual":"q0Z3c00a"};